import { isAxiosError } from "axios"

/** The "Err msg" of a Sequence server error body (object or JSON text), or null. */
export const sequenceErrorOf = (data: unknown): string | null => {
  let value = data
  if (typeof value === "string") {
    if (!value.trimStart().startsWith("{")) return null
    try {
      value = JSON.parse(value)
    } catch {
      return null
    }
  }
  if (typeof value === "object" && value !== null && "Err msg" in value) {
    const message = (value as Record<string, unknown>)["Err msg"]
    return typeof message === "string" ? message : String(message)
  }
  return null
}

/** The longest body text shown as it is; a longer one is cut and ends in "...". */
const MAX_BODY_LENGTH = 2000

/**
 * What the server said about a failed request: its "Err msg" or body text, else the error's
 * message. An HTML body (a proxy's error page) is not shown, and a long one is cut.
 */
export const serverMessageOf = (error: unknown, fallback: string): string => {
  if (isAxiosError(error)) {
    const data: unknown = error.response?.data
    const sequenceError = sequenceErrorOf(data)
    if (sequenceError) return sequenceError
    if (typeof data === "string") {
      const body = data.trim()
      if (body !== "" && !body.startsWith("<"))
        return body.length > MAX_BODY_LENGTH ? `${body.slice(0, MAX_BODY_LENGTH)}...` : body
    }
  }
  if (error instanceof Error && error.message) return error.message
  return fallback
}
